import AlertesHomeService from "@services/alertes-home-service";
import { initialiseComponents } from "../../core";
import Component from "../component.abstract";

interface AlertesHomesProps {
  url: string;
}

export default class AlertesHome extends Component {
  private url: string;
  private service: AlertesHomeService;
  public data: any;
  constructor(private props: AlertesHomesProps, element: HTMLElement) {
    super(props, element);
    this.url = props.url;
  }

  mounted(): void {
    if (this.url) {
      this.call(this.url);
    }
  }
  call(url: string): void {
    this.service = new AlertesHomeService(url);
    this.service.post({}, this.displayAlerts.bind(this));
    this.service.setErrorHandler((error: any) => {
      this.data = error;
      this.displayAlerts({
        items: [],
        functions: [],
        cities: [],
      });
    });
  }
  displayAlerts(response: any): void {
    this.data = response;
    
     const alerteBloc = document.querySelector("div[data-alerte-home]");

     const div = document.createElement("div");
     div.setAttribute("class", "hide");
     if (response.items.length !== 0) {
       div.setAttribute("data-alertes-liste", "");
     } else if (response.functions.length > 0 && response.cities.length > 0 && response.contracts.length > 0) {
       div.setAttribute("data-alertes-criteres", "");
     } else {
       div.setAttribute("data-alertes-vide", "");
     }

     alerteBloc.appendChild(div);

     initialiseComponents();
     PubSub.publish("alertes-home.loaded", this);

  }

}
